var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"chip color-green",class:{ border: _vm.outlined }},[_c('span',{staticClass:"medium-20",class:{ 'regular-12': _vm.outlined }},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }